// extracted by mini-css-extract-plugin
module.exports = {"optionInput":"Forms_optionInput__2c9cE","form":"Forms_form__2U1a6","textfield":"Forms_textfield__3oaTF","errortext":"Forms_errortext__1h9uG"};